var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 847.23 266.09",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 266.09)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3316.8 1561.4 217.01-217.01-217.01-217.01-217.01 217.01 217.01 217.01",
    fill: "#6ccdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3533.8 1778.6 217.01-217.01-217.01-217.01-217.01 217.01 217.01 217.01",
    fill: "#36b75a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3750.9 1995.7 217.01-217.01-217.01-217.01-217 217.01 217 217.01",
    fill: "#51232c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3750.8 1561.5 217.01-217.01-217.01-217.01-217.01 217.01 217.01 217.01",
    fill: "#8ad03c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3968 1778.5 217.01-217-217.01-217.01-217 217.01 217 217",
    fill: "#36b75a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4185 1561.4 217.01-217.01-217.01-217.01-217.01 217.01 217.01 217.01",
    fill: "#6ccdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4008.2 811.04h-170.76v-801.99h488.69v168.12h-317.93v633.87",
    fill: "#36b75a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4439.3 811.04h170.77v-801.99h-170.77v801.99",
    fill: "#36b75a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4783.1 810.82v-801.99h170.77v532.6l386.33-532.6h143.85v801.99h-170.77v-477l-342.64 477.22-187.54-0.219",
    fill: "#36b75a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5658.5 811.04h170.77v-801.99h-170.77v801.99",
    fill: "#36b75a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6049.1 421.41 287.92 389.41-186.65 0.219-289.69-390.29 305.35-411.7h188.2l-305.13 412.36",
    fill: "#36b75a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.77 811.04h-170.77v-801.99h488.7v168.12h-317.93v633.87",
    fill: "#51232c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3140.5 9.0508h524v168.12h-353.23v152.01h285.94v168.12h-285.94v145.62h353.23v168.12h-524v-801.99",
    fill: "#51232c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m949.6 171.87c-131.72 0-238.5 106.79-238.5 238.51 0 131.71 106.78 238.5 238.5 238.5 131.72 0 238.5-106.79 238.5-238.5 0-131.72-106.78-238.51-238.5-238.51zm0 648.22c-226.15 0-409.71-183.35-409.71-409.71 0-226.15 183.34-409.72 409.71-409.72 226.37 0 409.71 183.35 409.71 409.72 0 226.14-183.34 409.71-409.71 409.71",
    fill: "#51232c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2718.8 400.67v-118.04h95.1v-91.117s-57.15-20.301-135.69-20.301c-131.72 0-238.51 106.79-238.51 238.5 0 131.72 106.79 238.51 238.51 238.51 65.75 0 125.32-26.699 168.56-69.719l121.13 121.12c-74.14 74.141-176.51 119.81-289.47 119.81-226.15 0-409.72-183.35-409.72-409.72 0-226.14 183.35-409.71 409.72-409.71 202.54 0 271.82 71.039 306.23 106.35v294.32h-265.86",
    fill: "#51232c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1783.6 179.82h-142.75v460.01h142.75c127.96 0 231.66-103.03 231.66-230.12 0-127.08-103.7-229.89-231.66-229.89zm0.88 631.88h-0.44-313.96v-802.43h313.52 1.1c221.95 0 401.99 179.59 401.99 401.33-0.22 221.29-180.26 401.1-402.21 401.1",
    fill: "#51232c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.022e1c95ab7c14e3ec27ea092f3ef029.svg";
export { ForwardRef as ReactComponent };